import React, { useEffect, useState, Fragment, useContext } from "react";
import { Select } from "semantic-ui-react";

import { withRouter } from "react-router-dom";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import UserContext from "./../UserContext";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}));

const Companies = () => {
  let history = useHistory();
  const { setConfig, notifySuccess } = useContext(UserContext);
  // const userStore = useContext(UserContext);
  const [companies, setCompanies] = useState();
  // const [employeeRole,setRole]=useState();
  const [open, setOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(false);
  const classes = useStyles();

  const handleOpen = selectedCompany => {
    setSelectedCompany(selectedCompany);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    axios
      .get(
        "https://testapp20200313053149.azurewebsites.net/api/company",
        setConfig
      )
      .then(data => {
        setCompanies(data.data);
      });
  }, []);

  

  return (
    <Fragment>
      <div
        style={{
          display: "flex",
          WebkitJustifyContent: "space-around",
          paddingRight: "50%",
          alignItems: "baseline"
        }}
        className="item"
      >
        <h1 style={{ margin: 0 }}>Companies</h1>

        <h1 style={{ margin: 0 }}>Employees</h1>
      </div>
      <div className="ui celled list">
        <Fragment>
          {companies
            ? companies.map(company => (
                <div
                  className="item"
                  style={{
                    display: "flex",
                    WebkitJustifyContent: "space-around"
                  }}
                  key={company.Id}
                >
                  <div className="content">
                    <div className="header">{company.CompanyName}</div>
                    {company.CompanySector}
                  </div>
                  <select
                    className="ui dropdown"
                    onChange={companyUser =>
                      history.push(`/user/${companyUser.currentTarget.value}`)
                    }
                  >
                    <option value=""></option>
                    {company.AppUsers.map(companyUser => (
                      <option
                        key={companyUser.Id}
                        className="item"
                        data-value={company.CompanyName}
                        value={companyUser.Id}
                      >
                        {companyUser.FirstName} {companyUser.LastName}
                      </option>
                    ))}
                  </select>

                  
                </div>
              ))
            : "No Companies registered"}
        </Fragment>
      </div>
      
          
    </Fragment>
  );
};
export default withRouter(Companies);
